import React from 'react';
import styles from './TableBox.module.scss';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import { tooltipStyle, tooltip, ImgCell } from '@/components/TableCell';

const TableBox = ({
    onPageJump,
    levelList
}) => {

    const onOperateCell = (key) => {
        return <div className={styles.action}>
            <div
                className={styles.item}
                onClick={() => onPageJump('编辑骑士等级', `/editlevel/${key}`)}
            >编辑</div>
            {/* <div
                className={styles.item}
                onClick={() => onTableOperate(key, 'remove')}
            >删除</div> */}
        </div >;
    };

    const columns = [
        {
            title: '骑手等级',
            dataIndex: 'level',
            key: 'level',
            width: '12%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '等级称谓',
            dataIndex: 'name',
            key: 'name ',
            width: '12%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '等级背景',
            dataIndex: 'backgroundLogo',
            key: 'backgroundLogo',
            width: '12%',
            align: 'center',
            onCell: tooltipStyle,
            render: ImgCell
        },
        {
            title: '等级logo',
            dataIndex: 'logo',
            key: 'logo',
            width: '12%',
            align: 'center',
            onCell: tooltipStyle,
            render: ImgCell
        },
        {
            title: '权益说明',
            dataIndex: 'rightsMemo',
            key: 'rightsMemo',
            width: '12%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '所需分值',
            dataIndex: 'score',
            key: 'score',
            width: '12%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        // {
        //     title: '接单数量',
        //     dataIndex: 'ordersNum',
        //     key: 'ordersNum',
        //     width: '12%',
        //     align: 'center',
        //     onCell: tooltipStyle,
        //     render: tooltip
        // },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            width: '12%',
            align: 'center',
            onCell: tooltipStyle,
            render: onOperateCell
        }
    ];

    return <div>
        <Table
            rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
            rowKey={record => record.id}
            columns={columns}
            dataSource={levelList}
            pagination={false}
            scroll={{ y: true }}
        />
    </div>;
};

TableBox.propTypes = {
    onPageJump: PropTypes.func,
    levelList: PropTypes.array
};
export default TableBox;